import { NewWaybillModalComponent } from './../new-waybill/newWaybillModal.component';
import { InternalService } from './../../services/internal.service';
import { UbigeoService } from './../../services/ubigeo.service';
import { WaybillService } from './../../services/waybill.service';
import { Component, ViewEncapsulation, Input, OnDestroy, NgZone , Renderer2} from '@angular/core';
import { MatDialogRef,MatDialog } from '@angular/material';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { ListofvaluesService } from '../../services/listofvalues.service';
import { ProviderService } from '../../services/provider.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-specific-waybill-modal',
  templateUrl: './specific-waybill-modal.component.html',
  styleUrls: ['./specific-waybill-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ListofvaluesService, ProviderService, WaybillService,UbigeoService]
})
export class SpecificWaybillModalComponent implements OnDestroy  {

  modalTitle = 'GUIA DE REMISION';
  buttonText = '';
  waybillData:any = {};
  subscription: Subscription;
  action: string;
  motivos:string[]=['Venta','Compra','','Traslado entre establecimiento de la misma empresa','','','','Importación',
  'Exportación','','','','Otros','Venta sujeta a confirmación del comprador','','','','Traslado por emisor itinerante de comprobantes de pago',
  'Traslado zona primaria'];
  doc='';
  t_transport='';
  motivoSelected=''
  fecha_translado:any;
  
  constructor(public dialogRef: MatDialogRef<SpecificWaybillModalComponent>,
    private notifierService: NotifierService,
    private waybillService: WaybillService,
    private ubigeoService: UbigeoService,
    private zone: NgZone,
    private ren:Renderer2, 
    private routes: Router,
    private dialog: MatDialog,
    private internalService: InternalService) {

      let el = document.getElementsByClassName('mat-dialog-container').item(0);
        ren.setStyle(el, 'overflow-y', 'scroll')

      this.internalService.internalListener.subscribe(
        (result: any) => {
          this.waybillData=result.message;
          this.t_transport=this.waybillData.transport_type == 1 ? 'Transaporte publico':'Transporte Privado';
          this.doc=this.waybillData.document_type_driver == 1 ? 'DNI':'RUC';
          this.motivoSelected=this.motivos[Number(this.waybillData.dispatch_reason)-1];
          this.fecha_translado=this.waybillData.start_dispatch_date.slice(0,10)
          console.log(this.waybillData)
        }
      )
  }

  close() {
      this.dialogRef.close();
  }

  emitElectronic(){
    this.waybillService.electronicWaybill(this.waybillData.id).subscribe(
      result => {
        console.log(result)
        this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Guia electronica emitida correctamente.',
            duration: 4000,
            type: 'success'
          });
          this.dialog.closeAll();
          //this.routes.navigate(['/system/waybill/list']);
      },
      error =>{
          console.log(error);
          this.notifierService.systemNotify({
          title: 'Error',
          message: error.error.message,
          type: 'error',
          duration: 5000,
          });
      }
    );
  }

  anulate(){
    this.waybillService.anulate(this.waybillData.id).subscribe(
      result => {
        console.log('result',result)
        this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Guia electronica anulada correctamente.',
            duration: 4000,
            type: 'success'
          });
          this.dialog.closeAll();
        //this.routes.navigate(['/system/waybill/list']);
      },
      error =>{
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ocurrio un error al anular la Guia electronica.',
            type: 'error',
            duration: 5000,
          });
      })
  }

  delete(){
    this.waybillService.delete(this.waybillData.id).subscribe(
      result => {
        console.log('result',result)
        this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Guia eliminada correctamente.',
            duration: 4000,
            type: 'success'
          });
          this.dialog.closeAll();
        //this.routes.navigate(['/system/waybill/list']);
      },
      error =>{
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ocurrio un error al eliminar la Guia electronica.',
            type: 'error',
            duration: 5000,
          });
      })
  }

  edit(){
    //this.internalService.internalNotify({ numGuide: this.waybillData.number_guide, data: this.waybillData})
    console.log(this.waybillData)
    const dialogRef = this.dialog.open(NewWaybillModalComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log('cerro')
      this.dialogRef.close();
    });
  }

  pdf(){
    if(this.waybillData.url_nubefact)
      (window as any).open(this.waybillData.url_nubefact, "_blank");
  }

  ngOnDestroy() {
      this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/system/waybill/specific-waybill-modal/specific-waybill-modal.component.ts